import React from 'react';
import { Backdrop, CircularProgress } from '@mui/material';

function Loader({ id, isOpen }) {
  return (
    <Backdrop
      id={`${id}__backdrop_loader`}
      sx={{
        zIndex: (theme) => Math.max(...Object.values(theme.zIndex)) + 1, // Displays loader above all the Dialog components
      }}
      open={isOpen}
    >
      <CircularProgress id={`${id}__circularProgress_loader`} sx={{ color: 'primary.dark' }} />
    </Backdrop>
  );
}

export default Loader;
